import React from 'react';
import { useTableScroll } from './useViewportFit';
import './table.css';

/*
 * Low-level table parts, styled exactly like DataTable. Use DataTable for data lists; use these
 * parts only when a table needs fully custom rows (inline editing, merged cells, nested rows).
 *
 *   <TableContainer>                       // bordered, scrollable card
 *     <Table sticky>
 *       <TableHead><TableRow><TableHeader>Plate</TableHeader></TableRow></TableHead>
 *       <TableBody><TableRow><TableCell>DXB A 41287</TableCell></TableRow></TableBody>
 *     </Table>
 *   </TableContainer>
 */
/**
 * Scrolling and the sticky header follow useTableScroll: a table that fits the width lets the page
 * scroll with its header stuck under the top bar; a wider (or "70vh") table fills the rest of the
 * screen and scrolls inside; a px maxHeight or a dialog keeps its own limit.
 */
export const TableContainer = ({ className = '', maxHeight, style, ref: outerRef, ...p }) => {
    const box = useTableScroll({ maxHeight });
    const setRef = (node) => {
        box.ref.current = node;
        if (typeof outerRef === 'function') outerRef(node);
        else if (outerRef) outerRef.current = node;
    };
    return (
        <div
            ref={setRef}
            className={`table-card ${box.pageSticky ? 'is-page-sticky' : ''} ${className}`}
            style={box.style ? { ...box.style, ...style } : style}
            {...p}
        />
    );
};
export const Table = ({ className = '', sticky, ...p }) => <table className={`yelo-table ${sticky ? 'yelo-grid-sticky' : ''} ${className}`} {...p} />;
export const TableHead = ({ className = '', ...p }) => <thead className={`yelo-thead ${className}`} {...p} />;
export const TableBody = ({ className = '', ...p }) => <tbody className={`yelo-tbody ${className}`} {...p} />;
export const TableRow = ({ className = '', ...p }) => <tr className={`yelo-tr ${className}`} {...p} />;
export const TableHeader = ({ scope, className = '', align, ...p }) => (
    <th scope={scope || 'col'} className={`yelo-th ${align === 'end' ? 'align-end' : align === 'center' ? 'align-center' : ''} ${className}`} {...p} />
);
export const TableCell = ({ isHeader, className = '', align, ...p }) => {
    const cls = `${isHeader ? 'yelo-th' : 'yelo-td'} ${align === 'end' ? 'align-end' : align === 'center' ? 'align-center' : ''} ${className}`;
    return isHeader ? <th scope="col" className={cls} {...p} /> : <td className={cls} {...p} />;
};
